import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN;

const apiBase = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_BASE_URL || '';

if (dsn) {
  Sentry.init({
    dsn,
    tunnel: `${apiBase}/api/sentry-tunnel`,
    environment: process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development',
    release: process.env.REACT_APP_VERSION || undefined,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
      Sentry.feedbackIntegration({
        autoInject: false,
        colorScheme: 'light',
        submitButtonLabel: 'Send Feedback',
        cancelButtonLabel: 'Cancel',
        formTitle: 'Share Your Feedback',
        messagePlaceholder: 'Tell us about a bug, something confusing, or an idea to improve DreamUp.',
        successMessageText: 'Thank you! Your feedback helps us improve DreamUp.',
        showBranding: false,
        themeLight: {
          accentBackground: '#0088FF',
          accentForeground: '#ffffff',
          submitBackground: '#0088FF',
          submitBackgroundHover: '#0066CC',
          submitBorder: '#0088FF',
          submitOutlineFocus: '#74D8F7',
          inputOutlineFocus: '#0088FF',
        },
      }),
    ],
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.2 : 1.0,
    replaysSessionSampleRate: 0.1,  // Record 10% of sessions
    replaysOnErrorSampleRate: 1.0,  // Always record sessions with errors
  });
}

export { Sentry };

/**
 * Open the Sentry feedback dialog programmatically.
 */
export async function openFeedback(): Promise<void> {
  const feedback = Sentry.getFeedback();
  if (feedback) {
    const form = await feedback.createForm();
    form.appendToDom();
    form.open();
  }
}

/**
 * Set user context after login.
 */
export function setSentryUser(userId: string, email?: string): void {
  Sentry.setUser({ id: userId, email });
}

/**
 * Clear user context on logout.
 */
export function clearSentryUser(): void {
  Sentry.setUser(null);
}
